<template>
  <div class="user-main-data">

    <div class="user-avatar"></div>

    <div class="col user-data-col-gap">

      <div class="data-row user-row-gap">

        <div class="vertical-field">

          <div class="field-label">
            Email:
          </div>

          <div>
            {{ applicationUser.email || '&nbsp;' }}
          </div>

        </div>

        <div class="vertical-field">

          <div class="field-label">
            Телефон:
          </div>

          <div>
            {{ applicationUser.phone || '&nbsp;' }}
          </div>

        </div>

      </div>

      <div class="vertical-field">

        <div class="field-label">
          Имя:
        </div>

        <div>
          {{ applicationUser.name || '&nbsp;' }}
        </div>

      </div>
      <div class="vertical-field">

        <div class="field-label">
          Прочая информация:
        </div>

        <div>
          {{ applicationUser.info || '&nbsp;' }}
        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
  props: {
    applicationUser: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.user-main-data {
  display: flex;
  align-items: start;
  gap: 32px;
}
.user-data-col-gap {
  gap: 16px;
}
.user-avatar {
  width: 120px;
  height: 160px;
  background-color: rgba(0, 0, 0, 0.02);
  border: 1px dashed rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}
.user-row-gap{
  gap: 64px;
}
</style>
